import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
  light?: boolean;
};
export function Countdown({
  className = '',
  light = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['seg', seconds % 60]];
  return <div className={`inline-flex items-start gap-2 rounded-lg border px-4 py-2 font-mono font-black ${light ? 'border-gold/60 bg-navyDeep text-gold' : 'border-line bg-panel text-skyDeep'} ${className}`} aria-label="Tiempo restante de la oferta" data-id="element-258" data-mp="1xfs30k0p6rmm">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-259" data-mp="34u4yf0biovcl" data-mpi={index}>
          {index > 0 && <span className="pt-1 text-xl opacity-40" data-id="element-260" data-mp="34tbz2kew184h">:</span>}
          <span className="flex min-w-[38px] flex-col items-center leading-none" data-id="element-261" data-mp="2c8gfwiv41k5f">
            <b className="text-xl" data-id="element-262" data-mp="2h6i2vevnq3m6">{String(value).padStart(2, '0')}</b>
            <small className="mt-1 font-sans text-[9px] font-bold uppercase tracking-wider opacity-70" data-id="element-263" data-mp="2h8kzwiv88x0e">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}